<router-outlet></router-outlet>
<app-menu [pages]=pages></app-menu>
<!-- <div class="loading-block" *ngIf="!pages">
  <div class="progress-bar-load blue"></div>
  <div class="progress-bar-load"></div>
</div> -->
<app-footer></app-footer>
